import React from "react";
import _ from "lodash";
import FlexBox from "../ui/FlexBox";
import Utils from "../../helpers/Utils";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  patientInfo: {
    display: "flex",
    width: "fit-content",
    gap: "12px",
    padding: "8px",
    borderRadius: "3px",
    color: (props) => (props.color ? props.color : "#fff"),
    backgroundColor: (props) => (props.bgColor ? props.bgColor : "#9caf46"),
  },
}));

export const PatientInfo = ({ patient, bgColor = "#9caf46", color = "#fff" }) => {
  const gender = _.get(patient, "gender.name");
  const { patientInsurances } = useSelector((store) => store.chart);
  const classes = useStyles({ bgColor, color });

  return (
    <div className={classes.patientInfo}>
      <div className="d-flex flex-column">
        <p className="mb-0">Patient</p>
        <FlexBox className="name" justify="space-between">
          {Utils.getFullName(patient)} <span>{patient?.vipPatient && "VIP"}</span>
        </FlexBox>
      </div>
      <div className="d-flex flex-column flex-shrink-0">
        <p className="mb-0 pl-2">Chart No</p>
        <FlexBox className="pl-2">{patient.chartNumber}</FlexBox>
      </div>
      <div className="d-flex flex-column flex-shrink-0">
        <p className="mb-0">Patient Details</p>
        {gender && (
          <FlexBox>
            {gender}, Age: {Utils.getAge(patient?.dateOfBirth)},{" "}
            {(patientInsurances || []).find((item) => item?.type?.code === "PRIMARY")?.insurancePlan
              ?.name || "N/A"}
          </FlexBox>
        )}
      </div>
    </div>
  );
};
